module.exports = __webpack_public_path__ + "static/media/tech4.6afc9b4e.jpeg";